import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Error.svg'

export const IconError = IconSVG as IconComponent
